import React from 'react'
import CommWhatsAppCompose from './CommWhatsAppCompose'

// Created By Cursor
const CommComposeHomework = (props) => (
  <CommWhatsAppCompose {...props} titleHint="Homework" />
)

export default CommComposeHomework
